// extracted by mini-css-extract-plugin
export default {"bar":"BarChartBar_bar__ksvWq","barSectionContainer":"BarChartBar_barSectionContainer__LQA-T","legend":"BarChartBar_legend__tRbns"};